"use client"
import React,{ useState, useEffect } from 'react';
import Minicart from '../minicart/renderer';
import Menu from '../menu/renderer';
import logo from '../../../../public/static/images/icon_white.svg';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import '../../../styles/2-layout/_3-navigation.scss';
import ThemeContextProvider from "../../context/ThemeContextProvider";
import { getBaseUrl } from "../../utils/UrlManager";
import {GoogleAnalytics, GoogleTagManager} from "@next/third-parties/google";

export default function GermanHeader () {
    const [homeUrl, setHomeUrl] = useState('');
    useEffect(() => {
        // added loading link in here as was throwing error
        let loadUrl = getBaseUrl();
        setHomeUrl(loadUrl);
    }, []);

    return <div className="header-wrapper bg-black padding">
        <GoogleTagManager gtmId="GTM-54SLM3BZ" />
        <GoogleAnalytics gaId="G-DJYLFNCP00" />
        <Container className="header-container">
            <Grid container spacing={2} className="header no-margin">
                <Grid className="menu" xs={3} display="flex"  justifyContent="left" alignItems="center">
                    <ThemeContextProvider>
                        <Menu/>
                    </ThemeContextProvider>
                </Grid>
                <Grid className="logo" xs={6} display="flex"  justifyContent="center" alignItems="center">
                    <a href={ homeUrl } title="Sons UK">
                        <img src={ logo.src } height="42" alt="logo"/>
                    </a>
                </Grid>
                <Grid className="minicart" xs={3} display="flex" justifyContent="right" alignItems="center">
                    <Minicart/>
                </Grid>
            </Grid>
        </Container>
    </div>
}